"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fast_xml_parser_1 = __importDefault(require("fast-xml-parser"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const parseSvgFile = (source) => {
    const rawSvg = fast_xml_parser_1.default.parse(source, {
        ignoreAttributes: false,
    });
    if (!(0, valueIsRecord_1.default)(rawSvg)) {
        throw new Error(`An SVG should be a record: [${JSON.stringify(rawSvg)}]`);
    }
    const { svg } = rawSvg;
    if (svg === undefined) {
        throw new Error(`An SVG should have a prop named svg: [${JSON.stringify(rawSvg)}]`);
    }
    if (!(0, valueIsRecord_1.default)(svg)) {
        throw new Error('SVG should be a record');
    }
    const { '@_width': width, '@_height': height, '@_viewBox': viewBox, } = svg;
    if ((0, valueIsUndefined_1.default)(width) && (0, valueIsUndefined_1.default)(height) && (0, valueIsUndefined_1.default)(viewBox)) {
        throw new Error('Inside SVG must exist @_width, @_height or @_viewBox ');
    }
    if (!(0, valueIsUndefined_1.default)(viewBox) && !(0, valueIsString_1.default)(viewBox)) {
        throw new Error('Inside SVG @_viewBox should be a string or undefined');
    }
    if (!(0, valueIsUndefined_1.default)(width) && !(0, valueIsString_1.default)(width)) {
        throw new Error('Inside SVG @_width should be a string or undefined');
    }
    if (!(0, valueIsUndefined_1.default)(height) && !(0, valueIsString_1.default)(height)) {
        throw new Error('Inside SVG @_height should be a string or undefined');
    }
    return {
        svg: Object.assign(Object.assign({}, svg), { '@_width': width, '@_height': height, '@_viewBox': viewBox }),
    };
};
exports.default = parseSvgFile;
